// Types de documents supportés
export const DOCUMENT_TYPES = {
  pdf: { name: 'PDF', icon: '📄', extensions: ['.pdf'] },
  odt: { name: 'OpenOffice Writer', icon: '📃', extensions: ['.odt'] },
  ods: { name: 'OpenOffice Calc', icon: '📈', extensions: ['.ods'] },
  odp: { name: 'OpenOffice Impress', icon: '📺', extensions: ['.odp'] }
};